<div class="faq-container" *ngIf="content">
  <div class="faq">
    <h2 class="column__title">{{ content.fields.heading }}</h2>
    <p class="column__ingress">
      {{ content.fields.ingress }}
    </p>

    <app-questions-and-answers
      [questionsAndAnswers]="content.fields.questionsAndAnswers"
      [hideCategories]="content.fields.hideCategories"
    ></app-questions-and-answers>

    <ng-container *ngIf="content.fields.link1Url">
      <div class="more-questions">
        <a class="column__link" [routerLink]="content.fields.link1Url">
          {{ content.fields.link1Text }}
        </a>
      </div>
    </ng-container>
  </div>
</div>
